import moment from 'moment';

const dateToDay = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const messageDate = moment(date);
  return messageDate.calendar(null, {
    lastDay: '[Ayer]',
    sameDay: '[Hoy]',
    lastWeek: 'D/M',
    sameElse: 'D/M',
  });
};

export default dateToDay;
